import { HttpError } from "@/http/lib";
import { App } from "vue";

export const maintainWebsiteHandler = async <E extends HttpError>(
  error: E,
  app: App
) => {
  const store = app.config.globalProperties.$store;
  const router = app.config.globalProperties.$router;
  if (error.response) {
    const data = error.response.data;
    if (data?.code === 888) {
      await store.dispatch("maintain/setIsUpdating", true);
      await router.replace({ name: "login", query: { _r: Date.now() } });
    }
  }
};
